import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';
import { LottieLoadingLayout } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import fr from 'facet-rest';
import usePolling from 'Hooks/usePolling';
import {
  AccountOpeningV2PendingStepLayout,
} from './AccountOpeningV2PendingStepLayout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md' },
  }, overrideReadOnly);

const POLLING_INTERVAL = 1000;
const TOO_LONG = 30000;

export const AccountOpeningV2PendingStep = () => {
  const { pageContentResource, setPageContentCollection, loadPageContentLink } = usePageContentContext();

  // If this page takes too long then go to the taking too long step
  React.useEffect(() => {
    const timerId = setTimeout(() => {
      pageContentResource.withRelationship(fr.relationships.takingTooLong.name, (rel) => {
        loadPageContentLink(rel.link('related'));
      }, () => {
        // do nothing
      });
    }, TOO_LONG);

    return () => {
      clearTimeout(timerId);
    };
  }, []);

  usePolling(async () => {
    const [updated] = await pageContentResource.link('self').get();
    if (updated.meta().canSubmit()) {
      updated.submit().then((next) => {
        setPageContentCollection(next);
      });
    }
  }, POLLING_INTERVAL);

  return (
    <LottieLoadingLayout>
      <MetaResourceRenderer
        layout={AccountOpeningV2PendingStepLayout}
        resource={pageContentResource}
        onSubmit={setPageContentCollection}
        metaOverrideSet={metaOverrideSet}
      />
    </LottieLoadingLayout>
  );
};
